module.exports = __webpack_public_path__ + "img/hw4.18e716db.png";